import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

/** Public marketing content — one unauthenticated call, shared by every public page. */
export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);

  useEffect(() => {
    api
      .get("/site")
      .then(({ data }) => setSite(data))
      .catch(() => setSite(false));
  }, []);

  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
